module.exports = __webpack_public_path__ + "static/logo-SMS-latinoamerica-40521f21111c9c86c92171144533f590.jpg";